/** User-facing payment / UPI notices (keep copy centralized for quick edits). */
export const PHONEPE_UPI_OUTAGE_ALERT =
  'PhonePe UPI facing continue server error, Use Other UPI payments please!';

export const PHONEPE_UPI_OUTAGE_BADGE = 'Heads up';
